import { IIconProps } from "@/components/icons/interface";

/**
 * HP Client Theme - My Orders / Orders Total Icon
 * Lucide scroll-text style for home KPI stats
 */
const OrdersTotalIcon = (props: IIconProps) => {
  const iconColor = props.color || "#047857";
  const width = props.width ?? 24;
  const height = props.height ?? 24;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={iconColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M15 12h-5" />
      <path d="M15 8h-5" />
      <path d="M19 17V5a2 2 0 0 0-2-2H4" />
      <path d="M8 21h12a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v1a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v2a1 1 0 0 0 1 1h3" />
    </svg>
  );
};

export { OrdersTotalIcon };
